import React from 'react';
const LINKS = [{
  label: 'Terms & Conditions',
  href: '#terms'
}, {
  label: 'Privacy Policy',
  href: '#privacy'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  return <footer className="border-t border-line bg-charcoal py-8" data-id="element-58" data-mp="32onigxc1ze6b">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8" data-id="element-59" data-mp="32m1cv38q38qq">
        <p className="font-display text-base font-bold uppercase tracking-[0.12em] text-cream" data-id="element-60" data-mp="36ppktn19o6ci">
          Functional Coach System™
        </p>
        <nav aria-label="Footer" className="mt-4" data-id="element-61" data-mp="38h3r5ed5aiu">
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-62" data-mp="387fpncvpdfs">
            {LINKS.map(link => <li key={link.label} data-id="element-63" data-mp="3lgonyijc22op">
                <a href={link.href} className="text-[13px] font-medium text-mutedtext underline-offset-4 transition-colors duration-150 ease-out hover:text-gold hover:underline" data-id="element-64" data-mp="3qcnkwuiq8t0q">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mt-6 text-[12px] font-medium text-mutedtext" data-id="element-65" data-mp="3l9shv2i5sonf">
          © 2026 FUNCTIONAL COACH SYSTEM™ — All Rights Reserved.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[11px] leading-relaxed text-mutedtext/80" data-id="element-66" data-mp="3v89cc9gb3le8">
          This product is intended for educational and professional-development
          purposes. It does not replace professional certification,
          individualized medical advice, diagnosis, treatment or rehabilitation.
          Coaches should work within their qualifications and refer clients to
          appropriate healthcare professionals when necessary.
        </p>
      </div>
    </footer>;
}